import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { PrtIssuesCommon } from '../../models/itens.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-itens-ac-prt-issues',
  templateUrl: './itens-ac-prt-issues.component.html',
  styleUrls: ['./itens-ac-prt-issues.component.scss','../itens-edit/itens-edit.component.scss']
})
export class ItensAcPrtIssuesComponent extends BaseFormComponent<PrtIssuesCommon> implements OnInit {
  @Input() formArray: FormGroup = null;
  @Input() currentItem: object[] = [];
  @Input() parentId: number = null;
  constructor(
    public activatedRoute: ActivatedRoute,
  ) { 
    super(activatedRoute);
  }
  ngOnInit() {
  }

}
